import React, { useState } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import userApi from '../../api/userApi';
import { useNavigate } from 'react-router-dom';

const profiles = ['CONTRIBUENTE', 'STUDIO', 'ADMIN'];

export default function UtenteCreatePage() {
  const [form, setForm] = useState({ username: '', password: '', email: '', profile: 'CONTRIBUENTE' });
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await userApi.create(form);
      navigate('/users');
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
      <Typography variant="h5">Crea Utente</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField fullWidth sx={{ my: 1 }} label="Username" value={form.username} onChange={e => setForm({...form, username: e.target.value})} />
        <TextField fullWidth sx={{ my: 1 }} label="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <TextField fullWidth type="password" sx={{ my: 1 }} label="Password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
        <TextField select fullWidth sx={{ my: 1 }} label="Profile" value={form.profile} onChange={e => setForm({...form, profile: e.target.value})}>
          {profiles.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
        </TextField>
        <Button variant="contained" type="submit">Crea</Button>
      </form>
    </Container>
  );
}